/**
 * Corner Page.
 */
import MainContent from '@shared/types/enums/main';
import Rail from '@shared/classes/rail';
import Slider from '@shared/classes/slider';
import MainTemplate from '@components/templates/main/ui/main';
import cornerObservable from '@shared/api/corners/cornerObservable';
import useComplete from '@shared/components/utils/hooks/useComplete';
import { Observer } from 'rxjs';
import { selectCurrentParams } from '@shared/store/slices/router.slice';
import { useAppSelector } from '@shared/store/hooks';
import { useEffect, useState } from 'react';

/**
 * Displays the corner page with the rails and sliders.
 */
export default function Corner() {
  // Selectors
  const currentParams = useAppSelector(selectCurrentParams);

  // State
  const [complete, setComplete] = useComplete();
  const [rails, setRails] = useState<Rail[]>(
    (currentParams as { rails: Rail[] })?.rails || []
  );
  const [sliders, setSliders] = useState<Slider[]>(
    (currentParams as { sliders: Slider[] })?.sliders || []
  );

  useEffect(() => {
    if (currentParams?.rails || currentParams?.sliders) {
      return;
    }
    const id = (currentParams as { id: string }).id;
    const title = (currentParams as { title: string }).title;
    if (id) {
      const cornerObserver: Observer<{
        data: Slider[] | Rail[];
        type: number;
      }> = {
        next: (val) => {
          if (val.type === MainContent.SLIDERS) {
            setSliders(val.data as Slider[]);
          } else if (val.type === MainContent.RAILS) {
            setRails(val.data as Rail[]);
          }
        },
        error: () => {
          console.error('Error recovering corners');
        },
        complete: () => {
          setComplete(true);
          return null;
        },
      };
      cornerObservable(id, title).subscribe(
        cornerObserver as Partial<Observer<unknown>>
      );
    }
  }, []);

  return <MainTemplate flags={{ complete }} rails={rails} sliders={sliders} />;
}
